import React from "react";
import AboutUs from "../components/AboutUs";
import BlogPostsSection from "../components/BlogPoststSection";
import ContactUs from "../components/ContactUs";
import FQA from "../components/FQA";
import HeaderComponent from "../components/HeaderComponent";
import HeroSection from "../components/HeroSection";
import ScrollTopButton from "../components/ScrollTopButton";
import Services from "../components/Services";
import SiteFooter from "../components/SiteFooter";
import TeamMembers from "../components/TeamMembers";
import WhyUs from "../components/WhyUs";
import { navLinks, sectionIds } from "../data/siteContent";
import useLandingPageUi from "../hooks/useLandingPageUi";

function LandingPage() {
  const {
    activeSection,
    handleNavClick,
    handleScrollTop,
    isMobileNavOpen,
    showScrollTop,
    toggleMobileNav,
  } = useLandingPageUi(sectionIds);

  return (
    <>
      <HeaderComponent
        activeSection={activeSection}
        isMobileNavOpen={isMobileNavOpen}
        navLinks={navLinks}
        onNavigate={handleNavClick}
        onToggleMobileNav={toggleMobileNav}
      />

      <main className="main">
        <HeroSection />
        <AboutUs />
        <Services />
        <WhyUs />
        <TeamMembers />
        <FQA />
        <BlogPostsSection />
        <ContactUs />
      </main>

      <SiteFooter />
      <ScrollTopButton isVisible={showScrollTop} onClick={handleScrollTop} />
    </>
  );
}

export default LandingPage;
